export const state = {
  clients: [],
  totalClients: 0,
  loading: false,
  status: "",
  error: null,
  emailOfUserThatWasDeleted: "",
  subscription: {},
};
